import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-refund-comment-section',
  templateUrl: './refund-comment-section.component.html',
  styleUrls: ['./refund-comment-section.component.scss'],
})
export class RefundCommentSectionComponent {
  public commentData: any[] = [];
  public newCommentText: string = ''; // Bound to the textarea using ngModel
  public isSubmitting: boolean = false;
  public login_user_details: any = {};
  public productName: string = '';
  public updatetable: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RefundCommentSectionComponent>,
    private sanitizer: DomSanitizer,
    public cookieService: CookieService,
    private apiservice: ApiservicesService
  ) {
    this.login_user_details = this.cookieService.get('login_user_details')
      ? JSON.parse(this.cookieService.get('login_user_details'))
      : {};
    console.log('login_user_details===>', this.login_user_details);
  }

  ngOnInit(): void {
    // this.commentData = this.data?.commentList;
    const comments = this.data?.commentList?.[0]?.returnComment;
    const CommentData = this.data?.commentList;
    this.productName = this.data?.commentList?.[0]?.products?.[0]?.name;
    console.log('productName=====>', this.productName);

    if (Array.isArray(comments)) {
      comments.sort((a, b) => a.createdAt - b.createdAt);
      this.commentData = comments;
    }

    console.log('Comments to display:', this.commentData);

    console.log('commentData:===========>', CommentData);
  }

  addComment(): void {
    // if (!this.newCommentText.trim() || this.isSubmitting) {
    //   return;
    const text = (this.newCommentText || '').trim();
    if (!text || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;

    const requestObject = this.data?.commentList?.[0];
    const userType = this.login_user_details.userinfo.user_type;
    console.log('userType=====>', userType);

    if (!requestObject) {
      console.error('Error: Could not find the request data to add a comment.');
      this.isSubmitting = false;
      return;
    }

    const payload = {
      user_id: requestObject.user_id,

      return_request_id: requestObject._id,

      comment_text: this.newCommentText,

      user_type: userType,

      is_private_note: false,
    };
    console.log('payload====>', payload);

    const apiUrl = '/refund-processing/return-request-comment-add';
    this.apiservice.getHttpDataPost(apiUrl, payload).subscribe({
      next: (response: any) => {
        this.commentData.push(response.results);
        this.newCommentText = '';
        this.isSubmitting = false;
        console.log('Comment added successfully!', response);

        const actorName =
          this.login_user_details?.userinfo?.name ||
          this.login_user_details?.userinfo?.firstname +
            (this.login_user_details?.userinfo?.lastname
              ? ' ' + this.login_user_details.userinfo.lastname
              : '') ||
          'User';

        interface ActivityPayload {
          user_id: any;
          refundRequestId: any;
          type: string;
          description: string;
          actor: {
            userId: any;
            role: any;
            name: any;
            email: any;
          };
          metadata?: {
            Comment?: string;
          };
        }

        const activityPayload: ActivityPayload = {
          user_id: requestObject.user_id,
          refundRequestId: requestObject._id,
          type: 'COMMENT_ADDED',
          description: `${text}`,
          actor: {
            userId: this.login_user_details?.userinfo?._id,
            role: this.login_user_details?.userinfo?.user_type,
            name: actorName,
            email: this.login_user_details?.userinfo?.email || '',
          },
          metadata: {
            Comment: `${actorName} added a comment (${
              this.login_user_details?.userinfo?.user_type === 'customer'
                ? 'Customer'
                : ''
            }) "${text}"`,
          },
        };

        this.apiservice
          .getHttpDataPost(
            'refund-activity/refund-activity-add',
            activityPayload
          )
          .subscribe({
            next: () => {
              console.log('Activity for comment addition logged successfully.');
            },
            error: (err) => {
              console.error(
                'Failed to log activity for comment addition:',
                err
              );
            },
          });
      },
      error: (err) => {
        console.error('Failed to add comment:', err);
        this.isSubmitting = false;
      },
    });
  }

  closePopup() {
    this.dialogRef.close();
  }
}
